#@import GliveBooking.Presenters.Section
#@export GliveBooking.Views.Section

class GliveBooking.Views.Section extends BookingV2.Views.Base

  module: 'glive-booking'

  presenter: GliveBooking.Presenters.Section

  templateName: 'section'

  tagName: 'li'

  events:
    'click': 'select'

  select: ->
    @trigger('select', @model)
